/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    InstallmentInformationAprAbsent: {
        id: 'sph.sgLobSpecifics.InstallmentInformationAprAbsent',
        defaultMessage: 'The total amount will be payable by {installments} Direct Debit payments'
    },
    InstallmentInformationWithApr: {
        id: 'sph.sgLobSpecifics.InstallmentInformationWithApr',
        defaultMessage: 'The total amount will be payable by {installments} Direct Debit payments (APR: {apr}%)'
    },
    InstallmentInformationNoApr: {
        id: 'sph.sgLobSpecifics.InstallmentInformationNoApr',
        defaultMessage: 'The total amount will be payable by {installments} Direct Debit payments'
    },
    SupportBannerMessage: {
        id: 'sph.sgLobSpecifics.SupportBannerMessage',
        defaultMessage: 'If you need any additional support in relation to your policy with Saga, please complete the support services form '
    },
    SupportServicesLink: {
        id: 'sph.sgLobSpecifics.supportServicesLink',
        defaultMessage: 'here'
    },
    CarStep: {
        id: 'spm.sgLobSpecifics.carStep',
        defaultMessage: 'Car'
    },
    PropertyStep: {
        id: 'sph.sgLobSpecifics.propertyStep',
        defaultMessage: 'Property'
    },
    DriversStep: {
        id: 'spm.sgLobSpecifics.driversStep',
        defaultMessage: 'Driver(s)'
    },
    DetailsStep: {
        id: 'sph.sgLobSpecifics.detailsStep',
        defaultMessage: 'Details'
    },
    QuoteStep: {
        id: 'sgLobSpecifics.quoteStep',
        defaultMessage: 'Quote'
    },
    PaymentStep: {
        id: 'sgLobSpecifics.paymentStep',
        defaultMessage: 'Payment'
    },
    ConfirmationStep: {
        id: 'sgLobSpecifics.confirmationStep',
        defaultMessage: 'Confirmation'
    },
    RetrievalPageTenancyAgreementDecline: {
        id: 'sgLobSpecifics.tenancyAgreementDecline',
        defaultMessage: 'Unfortunately, we are no longer able to provide you with a quotation online. Please call us on {phoneNumber} where one of our Customer Service Advisers will be able to help.'
    },
    ReduceEnergyBillsName: {
        id: 'sgLobSpecifics.ReduceEnergyBillsName',
        defaultMessage: 'ReduceEnergyBills'
    },
    ReduceEnergyBillsHeader: {
        id: 'sgLobSpecifics.ReduceEnergyBillsHeader',
        defaultMessage: 'How to reduce energy bills at home'
    },
    ReduceEnergyBillsDescription: {
        id: 'sgLobSpecifics.ReduceEnergyBillsDescription',
        defaultMessage: 'The energy price rise is impacting millions of UK households. So, what changes can we make to keep costs down and reduce energy use at home?'
    },
    WorkingFromHomeName: {
        id: 'sgLobSpecifics.WorkingFromHomeName',
        defaultMessage: 'WorkingFromHome'
    },
    WorkingFromHomeHeader: {
        id: 'sgLobSpecifics.WorkingFromHomeHeader',
        defaultMessage: 'Working from home today?'
    },
    WorkingFromHomeDescription: {
        id: 'sgLobSpecifics.WorkingFromHomeDescription',
        defaultMessage: 'Take a quick break and make sure you\'ve got the right insurance for the type of work you do.'
    },
    GarageInsuranceName: {
        id: 'sgLobSpecifics.GarageInsuranceName',
        defaultMessage: 'GarageInsurance'
    },
    GarageInsuranceHeader: {
        id: 'sgLobSpecifics.GarageInsuranceHeader',
        defaultMessage: 'Garage Insurance'
    },
    GarageInsuranceDescription: {
        id: 'sgLobSpecifics.GarageInsuranceDescription',
        defaultMessage: 'Does a home insurance policy include your garage contents? Read our garage insurance guide.'
    },
    NewBoilerCostName: {
        id: 'sgLobSpecifics.NewBoilerCostName',
        defaultMessage: 'NewBoilerCost'
    },
    NewBoilerCostHeader: {
        id: 'sgLobSpecifics.NewBoilerCostHeader',
        defaultMessage: 'How much does a new boiler cost?'
    },
    NewBoilerCostDescription: {
        id: 'sgLobSpecifics.NewBoilerCostDescription',
        defaultMessage: 'We\'ll help you recognise the signs your boiler may be close to breaking down, find the best replacements, and estimate boiler prices so you can keep your home warm all year round.'
    },
    EngagementRingInsuranceName: {
        id: 'sgLobSpecifics.EngagementRingInsuranceName',
        defaultMessage: 'EngagementRingInsurance'
    },
    EngagementRingInsuranceHeader: {
        id: 'sgLobSpecifics.EngagementRingInsuranceHeader',
        defaultMessage: 'Engagement ring insurance'
    },
    EngagementRingInsuranceDescription: {
        id: 'sgLobSpecifics.EngagementRingInsuranceDescription',
        defaultMessage: 'Everything you need to know about engagement ring insurance.'
    },
    CarBreakDownName: {
        id: 'sgLobSpecifics.CarBreakDownName',
        defaultMessage: 'CarBreakDown'
    },
    CarBreakDownHeader: {
        id: 'sgLobSpecifics.CarBreakDownHeader',
        defaultMessage: 'What to do if your car breaks down'
    },
    CarBreakDownDescription: {
        id: 'sgLobSpecifics.CarBreakDownDescription',
        defaultMessage: 'Find out what to do if you get stranded in a broken-down car.'
    },
    KeylessCarTheftName: {
        id: 'sgLobSpecifics.KeylessCarTheftName',
        defaultMessage: 'KeylessCarTheft'
    },
    KeylessCarTheftHeader: {
        id: 'sgLobSpecifics.KeylessCarTheftHeader',
        defaultMessage: 'Keyless car theft explained'
    },
    KeylessCarTheftDescription: {
        id: 'sgLobSpecifics.KeylessCarTheftDescription',
        defaultMessage: 'Clueless about keyless? Here\'s all you need to know and some simple solutions to keep your car safe.'
    },
    ChildCarSeatName: {
        id: 'sgLobSpecifics.ChildCarSeatName',
        defaultMessage: 'ChildCarSeat'
    },
    ChildCarSeatHeader: {
        id: 'sgLobSpecifics.ChildCarSeatHeader',
        defaultMessage: 'Child car seat regulations'
    },
    ChildCarSeatDescription: {
        id: 'sgLobSpecifics.ChildCarSeatDescription',
        defaultMessage: 'Using a child car seat is a legal requirement in the UK. Find out what the rules are.'
    },
    DrivingAbroadName: {
        id: 'sgLobSpecifics.DrivingAbroadName',
        defaultMessage: 'DrivingAbroad'
    },
    DrivingAbroadHeader: {
        id: 'sgLobSpecifics.DrivingAbroadHeader',
        defaultMessage: 'Driving abroad'
    },
    DrivingAbroadDescription: {
        id: 'sgLobSpecifics.DrivingAbroadDescription',
        defaultMessage: 'What you need to know when driving your own vehicle or hiring a car abroad. Essential European driving checklist.'
    },
    PenaltyPointsName: {
        id: 'sgLobSpecifics.PenaltyPointsName',
        defaultMessage: 'PenaltyPoints'
    },
    PenaltyPointsHeader: {
        id: 'sgLobSpecifics.PenaltyPointsHeader',
        defaultMessage: 'How penalty points affect car insurance'
    },
    PenaltyPointsDescription: {
        id: 'sgLobSpecifics.PenaltyPointsDescription',
        defaultMessage: 'Everything you need to know about penalty points and car insurance.'
    },
    DelayedFlightName: {
        id: 'sgLobSpecifics.DelayedFlightName',
        defaultMessage: 'DelayedFlight'
    },
    DelayedFlightHeader: {
        id: 'sgLobSpecifics.DelayedFlightHeader',
        defaultMessage: 'Delayed flight assistance'
    },
    DelayedFlightDescription: {
        id: 'sgLobSpecifics.DelayedFlightDescription',
        defaultMessage: 'Plus and Standard customers can enjoy some quiet time in one of more than 950 airport lounges if your flight is delayed by one (Plus) or two (Standard) hours.'
    },
    TravelProtectName: {
        id: 'sgLobSpecifics.TravelProtectName',
        defaultMessage: 'TravelProtect'
    },
    TravelProtectHeader: {
        id: 'sgLobSpecifics.TravelProtectHeader',
        defaultMessage: 'Keeping valuables safe on holiday'
    },
    TravelProtectDescription: {
        id: 'sgLobSpecifics.TravelProtectDescription',
        defaultMessage: 'Here\'s how to keep your belongings safe while you\'re away having a great time.'
    },
    TravelGPName: {
        id: 'sgLobSpecifics.TravelGPName',
        defaultMessage: 'TravelGP'
    },
    TravelGPHeader: {
        id: 'sgLobSpecifics.TravelGPHeader',
        defaultMessage: 'Travel GP service'
    },
    TravelGPDescription: {
        id: 'sgLobSpecifics.TravelGPDescription',
        defaultMessage: 'We provide, as standard, unlimited access to online & telephone GP appointments on your holiday with the Saga GP Service.'
    },
    CancelledFlightsName: {
        id: 'sgLobSpecifics.CancelledFlightsName',
        defaultMessage: 'CancelledFlights'
    },
    CancelledFlightsHeader: {
        id: 'sgLobSpecifics.CancelledFlightsHeader',
        defaultMessage: 'Does travel insurance cover cancelled flights?'
    },
    CancelledFlightsDescription: {
        id: 'sgLobSpecifics.CancelledFlightsDescription',
        defaultMessage: 'See how travel insurance might be able to help with delayed and cancelled flights.'
    },
    HolidayChecklistName: {
        id: 'sgLobSpecifics.HolidayChecklistName',
        defaultMessage: 'HolidayChecklist'
    },
    HolidayChecklistHeader: {
        id: 'sgLobSpecifics.HolidayChecklistHeader',
        defaultMessage: 'Holiday checklist'
    },
    HolidayChecklistDescription: {
        id: 'sgLobSpecifics.HolidayChecklistDescription',
        defaultMessage: 'We can help you stay organised and hopefully give you peace of mind - meaning you can get on and enjoy your time away.'
    },
    BoostYourSystemName: {
        id: 'sgLobSpecifics.BoostYourSystemName',
        defaultMessage: 'BoostYourSystem'
    },
    BoostYourSystemHeader: {
        id: 'sgLobSpecifics.BoostYourSystemHeader',
        defaultMessage: 'Health tips for a strong immune system'
    },
    BoostYourSystemDescription: {
        id: 'sgLobSpecifics.BoostYourSystemDescription',
        defaultMessage: 'It\'s your first line of defence against ill health, so how can you keep it in tip-top shape?'
    },
    PreExistingConditionsName: {
        id: 'sgLobSpecifics.PreExistingConditionsName',
        defaultMessage: 'PreExistingConditions'
    },
    PreExistingConditionsHeader: {
        id: 'sgLobSpecifics.PreExistingConditionsHeader',
        defaultMessage: 'Confused about pre-existing conditions?'
    },
    PreExistingConditionsDescription: {
        id: 'sgLobSpecifics.PreExistingConditionsDescription',
        defaultMessage: 'Our guide will help you understand whether your past medical conditions are covered when you take out a new health insurance policy.'
    },
    OptionsCoverName: {
        id: 'sgLobSpecifics.OptionsCoverName',
        defaultMessage: 'OptionsCover'
    },
    OptionsCoverHeader: {
        id: 'sgLobSpecifics.OptionsCoverHeader',
        defaultMessage: 'Options to improve your cover'
    },
    OptionsCoverDescription: {
        id: 'sgLobSpecifics.OptionsCoverDescription',
        defaultMessage: 'Tailor and improve your Saga Health Insurance policy so you can have the cover that\'s right for you.'
    },
    HospitalChoiceName: {
        id: 'sgLobSpecifics.HospitalChoiceName',
        defaultMessage: 'HospitalChoice'
    },
    HospitalChoiceHeader: {
        id: 'sgLobSpecifics.HospitalChoiceHeader',
        defaultMessage: 'Your choice of hospital'
    },
    HospitalChoiceDescription: {
        id: 'sgLobSpecifics.HospitalChoiceDescription',
        defaultMessage: 'If you work for yourself, it really pays to stay healthy. See how health insurance could give you a speedy route to recovery if illness gets in the way of business.'
    },
    SelfEmployedName: {
        id: 'sgLobSpecifics.SelfEmployedName',
        defaultMessage: 'SelfEmployed'
    },
    SelfEmployedHeader: {
        id: 'sgLobSpecifics.SelfEmployedHeader',
        defaultMessage: 'Health insurance for the self-employed'
    },
    SelfEmployedDescription: {
        id: 'sgLobSpecifics.SelfEmployedDescription',
        defaultMessage: 'See how travel insurance might be able to help with delayed and cancelled flights.'
    },
    AddressInfo: {
        id: 'sgLobSpecifics.AddressInfo',
        defaultMessage: '{addressLine1} {addressLine2}, {addressLine3}, {city}, {county} {postalCode}'
    },
    VehicleInfo: {
        id: 'sgLobSpecifics.VehicleInfo',
        defaultMessage: '{make} {model}, {registrationNumber}'
    },
    DestinationInfo: {
        id: 'sgLobSpecifics.DestinationInfo',
        defaultMessage: 'Destination: {destination}'
    },
    DestinationSeeACompleteList: {
        id: 'sgLobSpecifics.DestinationSeeACompleteList',
        defaultMessage: '{destinationsAfterJoin} +{hiddenCountriesCount}'
    },
    SingleTrip: {
        id: 'sgLobSpecifics.SingleTrip',
        defaultMessage: 'Single trip'
    },
    AnnualTrip: {
        id: 'sgLobSpecifics.AnnualTrip',
        defaultMessage: 'Annual trip'
    },
    RegionEurope: {
        id: 'sgLobSpecifics.RegionEurope',
        defaultMessage: 'Europe'
    },
    RegionWorldIncl: {
        id: 'sgLobSpecifics.RegionWorldIncl',
        defaultMessage: 'Worldwide including U.S.A., Canada, Mexico and all Caribbean Islands'
    },
    RegionWorldExcl: {
        id: 'sgLobSpecifics.RegionWorldExcl',
        defaultMessage: 'Worldwide excluding U.S.A., Canada, Mexico and all Caribbean Islands'
    },
    TravelDetails: {
        id: 'sgLobSpecifics.TravelDetails',
        defaultMessage: 'Details'
    },
    TravelMedical: {
        id: 'sgLobSpecifics.TravelMedical',
        defaultMessage: 'Medical'
    },
    SmiAboutYou: {
        id: 'sgLobSpecifics.SmiAboutYou',
        defaultMessage: 'About you'
    },
    SmiReview: {
        id: 'sgLobSpecifics.SmiReview',
        defaultMessage: 'Review'
    },
    RetrievalPageLandlordErrorMessage: {
        id: 'sgLobSpecifics.RetrievalPageLandlordErrorMessage',
        defaultMessage: '<div>Sorry – since you got your quote, our landlord insurance has moved to our partner Uinsure. &lt;a href="https://saga.uinsure.co.uk/?utm_source=saga_website&utm_medium=cta_button&utm_campaign=new_business" target="_blank"&gt;Click here &lt;/a&gt;to start a new quote with Uinsure.</div>'
    },
    RetrievalPageTailormadeErrorMessage: {
        id: 'sgLobSpecifics.RetrievalPageTailormadeErrorMessage',
        defaultMessage: 'We\'re sorry, we no longer offer specialist high-value home insurance. We\'ve chosen Hiscox as a suitable provider of cover that may meet your needs. You can get a quote by calling them on {phoneNumber}. Hiscox will pay us an introductory fee if you buy a policy from them.'
    },
    HealthConditionText: {
        id: 'sgLobSpecifics.HealthConditionText',
        defaultMessage: 'health condition will affect your driving'
    },
    MedicalConditionText: {
        id: 'sgLobSpecifics.MedicalConditionText',
        defaultMessage: 'tell DVLA about a medical condition'
    },
    CountriesCoveredText: {
        id: 'sgLobSpecifics.CountriesCoveredText',
        defaultMessage: 'check which countries are covered'
    },
    DrivingEuropeText: {
        id: 'sgLobSpecifics.DrivingEuropeText',
        defaultMessage: 'Find out more about driving in Europe'
    },
    OtherVehiclesText: {
        id: 'sgLobSpecifics.OtherVehiclesText',
        defaultMessage: 'policy schedule'
    },
    FcdoAdviceText: {
        id: 'sgLobSpecifics.FcdoAdviceText',
        defaultMessage: 'essential reasons'
    },
    HealthPlanText: {
        id: 'sgLobSpecifics.HealthPlanText',
        defaultMessage: 'Saga HealthPlan'
    },
    ABIGuideText: {
        id: 'sgLobSpecifics.ABIGuideText',
        defaultMessage: 'ABI Guide to Buying Private Health Insurance'
    },
    PolicyBooksText: {
        id: 'sgLobSpecifics.PolicyBooksText',
        defaultMessage: 'policy books'
    },
    TimeWeekDaysHomeMotor: {
        id: 'sgLobSpecifics.TimeWeekDaysHomeMotor',
        defaultMessage: '8:30am to 8pm weekdays'
    },
    TimeSaturdayHomeMotor: {
        id: 'sgLobSpecifics.TimeSaturdayHomeMotor',
        defaultMessage: '9am to 5pm Saturday'
    },
    TimeSundayHomeMotor: {
        id: 'sgLobSpecifics.TimeSundayHomeMotor',
        defaultMessage: '9am to 5pm Sunday'
    },
    TimeWeekDaysTravel: {
        id: 'sgLobSpecifics.TimeWeekDaysTravel',
        defaultMessage: '8:30am to 7pm weekdays'
    },
    TimeSaturdayTravel: {
        id: 'sgLobSpecifics.TimeSaturdayTravel',
        defaultMessage: '8:30am to 5pm Saturday'
    },
    TimeSundayTravel: {
        id: 'sgLobSpecifics.TimeSundayTravel',
        defaultMessage: 'Closed Sunday'
    },
    TimeWeekDaysSmi: {
        id: 'sgLobSpecifics.TimeWeekDaysSmi',
        defaultMessage: '8:30am to 7pm weekdays'
    },
    TimeSaturdaySmi: {
        id: 'sgLobSpecifics.TimeSaturdaySmi',
        defaultMessage: '9am to 1pm Saturday'
    },
    TimeSundaySmi: {
        id: 'sgLobSpecifics.TimeSundaySmi',
        defaultMessage: 'Closed Sunday'
    },
    QuickQuoteSubHeaderMotor: {
        id: 'sgLobSpecifics.QuickQuoteSubHeaderMotor',
        defaultMessage: 'With Saga\'s quick quote you can get a quote for insuring your home or another car in just a few clicks.'
    },
    QuickQuoteSubHeaderMotorWithoutHome: {
        id: 'sgLobSpecifics.QuickQuoteSubHeaderMotorWithoutHome',
        defaultMessage: 'With Saga\'s quick quote you can get a quote for insuring another car in just a few clicks.'
    },
    QuickQuoteSubHeaderHome: {
        id: 'sgLobSpecifics.QuickQuoteSubHeaderHome',
        defaultMessage: 'With Saga\'s quick quote you can get a quote for insuring your car in just a few clicks.'
    }
});
